import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

const BrandaDegisimiPage = () => {
  useEffect(() => {
    document.title = 'Branda Değişimi - İzmir Tente Tamir | Kaliteli Branda Yenileme';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'İzmir genelinde profesyonel branda değişimi hizmeti. Eski brandanızı yeni, dayanıklı ve renkli kumaşlarla değiştiriyoruz. 0551 372 35 12');
    }
  }, []);

  const otherServices = [
    { title: 'Tente Tamiri', link: '/hizmetler/tente-tamiri' },
    { title: 'Tente Yenileme', link: '/hizmetler/tente-yenileme' },
    { title: 'Körüklü Tente Tamiri', link: '/hizmetler/koruklu-tente-tamiri' },
    { title: 'Mafsallı Tente Tamiri', link: '/hizmetler/mafsalli-tente-tamiri' }
  ];

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Header />
      <FloatingButtons />

      <div className="pt-20 md:pt-24">
        <div className="w-full h-64 md:h-96">
          <img
            src="https://public.readdy.ai/ai/img_res/3ad89f5cf65a11b2b775afeb6d6f1fd2.jpg"
            alt="Branda Değişimi"
            className="w-full h-full object-cover object-top"
          />
        </div>
      </div>

      <div className="pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <nav className="text-sm text-gray-500 mb-6 mt-8">
            <Link to="/" className="hover:text-gray-900 cursor-pointer">Anasayfa</Link>
            <span className="mx-2">/</span>
            <Link to="/hizmetler" className="hover:text-gray-900 cursor-pointer">Hizmetler</Link>
            <span className="mx-2">/</span>
            <span className="text-gray-900">Branda Değişimi</span>
          </nav>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
            <div className="lg:col-span-2">
              <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Poppins, sans-serif' }}>
                Branda Değişimi
              </h1>
              
              <p className="text-base text-gray-700 mb-6 leading-relaxed">
                Tentelerinizin kumaş kısmı olan branda, zamanla güneş ışınları, yağmur, rüzgar gibi dış etkenlerden dolayı yıpranır, solar ve eskir. Branda değişimi, tentenizin metal iskeletini koruyarak sadece kumaş kısmını yenilemek anlamına gelir. İzmir Tente Tamir olarak, eski brandanızı çıkarıp yerine yeni, dayanıklı ve estetik kumaşlar montajlıyoruz.
              </p>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Branda Değişimi Nedir?</h2>
              <p className="text-sm md:text-base text-gray-700 mb-6 leading-relaxed">
                Branda değişimi, mevcut tente sisteminizdeki eski, yıpranmış veya solmuş kumaşın çıkarılarak yerine yeni bir kumaş takılması işlemidir. Bu hizmet, tente iskeletiniz sağlamsa ve sadece kumaş kısmı eskimişse ideal bir çözümdür. Yeni tente almaya göre çok daha ekonomik ve hızlı bir yenileme yöntemidir.
              </p>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Ne Zaman Branda Değişimi Gerekir?</h2>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Aşağıdaki durumlarda branda değişimi yapılması önerilir:
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Renk Solması:</strong> Güneş ışınları nedeniyle brandanın rengi solmuş ve canlılığını kaybetmişse</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Yırtık ve Delikler:</strong> Kumaşta onarılamayacak kadar büyük yırtık veya delikler varsa</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Küf ve Lekeler:</strong> Temizlenemeyen küf, leke veya kir birikintileri oluşmuşsa</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Kumaş Aşınması:</strong> Branda incelmişse ve dayanıklılığını kaybetmişse</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Estetik Yenileme:</strong> Mekanınızın görünümünü değiştirmek ve yenilemek istiyorsanız</span>
                </li>
              </ul>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Branda Değişimi Süreci</h2>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Profesyonel branda değişimi sürecimiz şu adımlardan oluşur:
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">1. Ölçüm ve Keşif</h3>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Uzman ekibimiz, mevcut tentenizin ölçülerini alır ve iskelet durumunu kontrol eder. Hangi kumaş türünün uygun olacağını belirler.
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">2. Kumaş Seçimi</h3>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Size geniş renk, desen ve kumaş kalitesi seçenekleri sunuyoruz. İhtiyacınıza ve bütçenize uygun kumaşı birlikte seçiyoruz.
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">3. Eski Brandanın Sökülmesi</h3>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Eski branda özenle sökülerek çıkarılır. Bu sırada iskelet ve mekanizma kontrol edilir, gerekirse bakım yapılır.
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">4. Yeni Brandanın Montajı</h3>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                Yeni branda, profesyonel ekipmanlarla gergin ve düzgün bir şekilde monte edilir. Tüm dikişler ve bağlantı noktaları kontrol edilir.
              </p>

              <h3 className="text-lg md:text-xl font-semibold text-gray-900 mb-3 mt-6">5. Test ve Teslim</h3>
              <p className="text-sm md:text-base text-gray-700 mb-6 leading-relaxed">
                Montaj tamamlandıktan sonra tente test edilir ve size teslim edilir. Kullanım ve bakım konusunda bilgilendirme yapılır.
              </p>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Kullandığımız Branda Kumaşları</h2>
              <p className="text-sm md:text-base text-gray-700 mb-4 leading-relaxed">
                İzmir Tente Tamir olarak kaliteli ve dayanıklı kumaşlar kullanıyoruz:
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Akrilik Kumaş:</strong> UV korumalı, su itici, renk haslığı yüksek</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>PVC Kumaş:</strong> Tamamen su geçirmez, dayanıklı, kolay temizlenebilir</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Polyester Kumaş:</strong> Ekonomik, hafif, çeşitli renk seçenekleri</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Şeffaf Branda:</strong> Işık geçirgenliği yüksek, modern görünüm</span>
                </li>
              </ul>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Branda Değişiminin Avantajları</h2>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Ekonomik:</strong> Yeni tente almaya göre çok daha uygun maliyetli</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Hızlı:</strong> Kısa sürede tamamlanır, uzun bekleme gerektirmez</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Çevre Dostu:</strong> Mevcut iskelet korunur, atık azalır</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Yenilenmiş Görünüm:</strong> Mekanınıza yeni bir hava katar</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Geniş Seçenek:</strong> Yüzlerce renk ve desen arasından seçim yapabilirsiniz</span>
                </li>
              </ul>

              <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 mt-8">Neden İzmir Tente Tamir?</h2>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Deneyimli Ekip:</strong> Yıllardır branda değişimi konusunda uzmanız</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Kaliteli Kumaş:</strong> Dayanıklı ve UV korumalı kumaşlar kullanıyoruz</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Hızlı Servis:</strong> Kısa sürede montaj ve teslim yapıyoruz</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Uygun Fiyat:</strong> Şeffaf ve rekabetçi fiyatlandırma</span>
                </li>
                <li className="flex items-start space-x-3">
                  <span className="w-1.5 h-1.5 bg-gray-900 rounded-full mt-2 flex-shrink-0"></span>
                  <span className="text-sm md:text-base text-gray-700"><strong>Garanti:</strong> Tüm işlemlerimiz garanti kapsamındadır</span>
                </li>
              </ul>

              <div className="bg-gray-50 rounded-xl p-6 md:p-8 mt-8">
                <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4">Hemen Teklif Alın</h2>
                <p className="text-sm md:text-base text-gray-700 mb-6">
                  Branda değişimi için ücretsiz keşif ve fiyat teklifi almak isterseniz bize ulaşın
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <a
                    href="tel:+905513723512"
                    className="px-5 py-2.5 bg-gray-900 hover:bg-gray-800 text-white text-sm font-semibold rounded-lg transition-colors text-center cursor-pointer whitespace-nowrap"
                  >
                    Telefon: 0551 372 35 12
                  </a>
                  <a
                    href={`https://wa.me/905513723512?text=${encodeURIComponent('Merhaba, izmirtentetamir.net web siteniz üzerinden yazıyorum.')}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-5 py-2.5 border-2 border-gray-900 hover:bg-gray-50 text-gray-900 text-sm font-semibold rounded-lg transition-colors text-center cursor-pointer whitespace-nowrap"
                  >
                    WhatsApp ile Yaz
                  </a>
                </div>
              </div>
            </div>

            <div className="lg:col-span-1">
              <div className="bg-white rounded-xl shadow-lg p-6 sticky top-24">
                <h3 className="text-base md:text-lg font-bold text-gray-900 mb-4">Diğer Hizmetlerimiz</h3>
                <ul className="space-y-3">
                  {otherServices.map((service, index) => (
                    <li key={index}>
                      <Link
                        to={service.link}
                        className="block p-3 bg-gray-50 hover:bg-gray-100 rounded-lg text-sm font-medium text-gray-900 transition-colors cursor-pointer"
                      >
                        {service.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default BrandaDegisimiPage;